import { ImageAvatar } from 'components/payment/payment-selector/payment-options/payment-option/payment-option.styles';
import styled from 'styled-components';

export const GoogleLogoAvatar = styled(ImageAvatar)`
  width: 25px;
  height: 25px;
`;
